import { RAISE_API_V1_URL } from "constants/endpoints";
import { post } from "services/api";

const SNIPPET_ID = "ze-snippet";

export const loadZendeskSnippet = (widgetKey) => {
  if (!widgetKey) return Promise.resolve(false);
  if (window.zE) return Promise.resolve(true);

  return new Promise((resolve, reject) => {
    const existing = document.getElementById(SNIPPET_ID);
    if (existing) {
      if (window.zE) {
        resolve(true);
        return;
      }
      existing.addEventListener("load", () => resolve(true), { once: true });
      existing.addEventListener(
        "error",
        () => reject(new Error("Failed to load Zendesk snippet")),
        { once: true }
      );
      return;
    }

    const script = document.createElement("script");
    script.id = SNIPPET_ID;
    script.async = true;
    script.src = `https://static.zdassets.com/ekr/snippet.js?key=${widgetKey}`;
    script.onload = () => resolve(true);
    script.onerror = () => reject(new Error("Failed to load Zendesk snippet"));
    document.head.appendChild(script);
  });
};

export const fetchZendeskMessagingToken = async () => {
  const response = await post(`${RAISE_API_V1_URL}/zendesk/authenticate`);
  const token = response?.data?.token;
  if (!token) {
    throw new Error("Zendesk authenticate did not return a token");
  }
  return token;
};

export const identifyZendeskUser = ({
  conversationTags = ["raise_logged_in"]
} = {}) => {
  if (!window.zE) return;

  window.zE("messenger", "hide");
  window.zE(
    "messenger",
    "loginUser",
    (callback) => {
      fetchZendeskMessagingToken()
        .then((token) => callback(token))
        .catch((error) => {
          console.error("Error authenticating user with Zendesk:", error);
        });
    },
    (error) => {
      if (error) {
        console.error("Zendesk loginUser failed:", error);
        return;
      }
      if (conversationTags.length) {
        window.zE("messenger:set", "conversationTags", conversationTags);
      }
      window.zE("messenger", "show");
    }
  );
};

export const logoutZendeskUser = () => {
  if (!window.zE) return;
  window.zE("messenger", "logoutUser");
};
